'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp; /**
                    * Created by Administrator on 2016/8/3.
                    */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactModal = require('react-modal');

var _reactModal2 = _interopRequireDefault(_reactModal);

var _SubmitBtn = require('../SubmitBtn/SubmitBtn');

var _SubmitBtn2 = _interopRequireDefault(_SubmitBtn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ServiceDetailTermsModal = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(ServiceDetailTermsModal, _Component);

  function ServiceDetailTermsModal() {
    (0, _classCallCheck3.default)(this, ServiceDetailTermsModal);

    var _this = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(ServiceDetailTermsModal).call(this));

    _this.state = {
      agree: false
    };
    return _this;
  }

  (0, _createClass3.default)(ServiceDetailTermsModal, [{
    key: 'onAgreeChange',
    value: function onAgreeChange(event) {
      this.setState({
        agree: event.target.checked
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = require('./ServiceDetailTermsModal.scss');
      var _props = this.props;
      var data = _props.data;
      var onSubmit = _props.onSubmit;
      var onClose = _props.onClose;
      var isOpened = _props.isOpened;
      var agree = this.state.agree;

      var customStyle = {
        content: {
          position: 'absolute',
          top: '40px',
          left: '40px',
          bottom: '40px',
          right: '40px',
          border: '1px solid #ccc',
          background: '#fff',
          borderRadius: '4px',
          overflow: 'auto',
          outline: 'none',
          padding: '20px',
          zIndex: 9999
        }
      };
      var content = '';
      if (data instanceof Array && data.length > 0) {
        content = data[0].content;
      }
      return _react2.default.createElement(
        _reactModal2.default,
        { style: customStyle, isOpen: isOpened },
        _react2.default.createElement(
          'form',
          { className: styles.component },
          content,
          _react2.default.createElement('div', { className: 'clear' }),
          _react2.default.createElement(
            'div',
            { className: styles.agree },
            _react2.default.createElement('input', { type: 'checkbox', checked: agree, onChange: function onChange(event) {
                return _this2.onAgreeChange(event);
              } }),
            _react2.default.createElement(
              'label',
              null,
              '阅读并同意条款'
            )
          ),
          _react2.default.createElement(_SubmitBtn2.default, { btnClick: onClose, text: '关闭' }),
          agree ? _react2.default.createElement(_SubmitBtn2.default, { btnClick: onSubmit, text: '确定' }) : _react2.default.createElement(
            'div',
            { className: styles.disabledBtn },
            '确定'
          )
        )
      );
    }
  }]);
  return ServiceDetailTermsModal;
}(_react.Component), _class.propTypes = {
  isOpened: _react.PropTypes.bool,
  data: _react.PropTypes.array,
  onClose: _react.PropTypes.func,
  onSubmit: _react.PropTypes.func
}, _temp);
exports.default = ServiceDetailTermsModal;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/ServiceDetailTermsModal/ServiceDetailTermsModal.js
 ** module id = 1415
 ** module chunks = 0
 **/